// import jsSocials plugin script
import 'jssocials';

// initialize social share element
$(function() {

	jsSocials.shares.print = {
		label: 'Print this page',
		logo: 'fa-light fa-print',
		shareUrl: '',
	};
	 
	$('#socialShare').jsSocials({
		showLabel: true, 
		showCount: false,
        shareIn : 'popup',
		shares:[{
				share: 'facebook',
				logo: 'fa-brands fa-facebook-f',
                label: 'Share on Facebook',
			},
			{
				share: 'twitter', 
				logo: 'fa-brands fa-x-twitter',
                label: 'Share on X (formerly Twitter)',
			},
			{
				share: 'linkedin', 
				logo: 'fa-brands fa-linkedin-in',
                label: 'Share on LinkedIn',
			},
			{
				share: 'email',
				logo: 'fa-light fa-envelope',
                label: 'Email this page',
			},
			'print', 
		],
		on:{
			click: function(e) {
				if(this.share === 'print'){
					window.print();
					return false;
				}
			},
		}
	});
});